if (!customElements.get('loogu-gallery-toggle')) {
  customElements.define('loogu-gallery-toggle', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.button = this.querySelector('button');
      if (!this.gallery || !this.button) return;
      this.gallery.classList.add('loogu-gallery-enhanced');
      this.controller?.abort();
      this.controller = new AbortController();
      this.button.addEventListener('click', () => {
        const expanded = this.gallery.classList.toggle('loogu-gallery-expanded');
        this.button.setAttribute('aria-expanded', String(expanded));
        this.querySelector('[data-show-more]').hidden = expanded;
        this.querySelector('[data-show-less]').hidden = !expanded;
        if (!expanded) this.button.scrollIntoView({block:'nearest', behavior:'instant'});
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
